import * as React from "react";
import {
  Edit,
  SimpleForm,
  TextField,
  required,
  SelectInput,
  Labeled,
  FunctionField,
  useTranslate,
  useEditContext,
} from "react-admin";
import { COUPON_STATUSES } from "@local/constants/index.js";
import { CustomToolbar, Title } from "../../shared/components/index.js";

const EditStatus = () => {
  const { record } = useEditContext();

  return (
    <SelectInput
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
      source="status"
      validate={[required()]}
      choices={Object.keys(COUPON_STATUSES).map((status) => {
        if (record.status === COUPON_STATUSES.locked.name) {
          return {
            id: status,
            name: `resources.Coupon.source.status.${status}`,
            disabled: status === COUPON_STATUSES.active.name ? false : true,
          };
        }

        if (record.status !== COUPON_STATUSES.locked.name) {
          return {
            id: status,
            name: `resources.Coupon.source.status.${status}`,
            disabled: status === COUPON_STATUSES.locked.name ? false : true,
          };
        }
      })}
    />
  );
};

const EditCoupon = () => {
  const t = useTranslate();

  return (
    <Edit
      redirect="show"
      title={<Title source="coupon_code" />}
      mutationMode="pessimistic"
    >
      <SimpleForm toolbar={<CustomToolbar />}>
        <Labeled
          label="resources.Coupon.fields.coupon_code"
          sx={{
            mt: 1,
            mb: 1,
          }}
        >
          <TextField source="coupon_code" />
        </Labeled>
        <Labeled
          label="resources.Coupon.fields.previous_state"
          sx={{
            mt: 1,
            mb: 1,
          }}
        >
          <FunctionField
            source="previous_state"
            render={(record) =>
              record.previous_state
                ? t(`resources.Coupon.source.status.${record.previous_state}`)
                : ""
            }
          />
        </Labeled>
        <EditStatus />
      </SimpleForm>
    </Edit>
  );
};

export default EditCoupon;
